import { ActionIcon, AppShell, Center, Divider, Stack } from "@mantine/core";
import { type PropsWithChildren } from "react";

import { useAuth } from "@/api/resources/auth/hooks";
import LayoutFooter from "@/components/Layout/LayoutFooter";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import NavbarIconList from "@/components/Navbar/NavbarIconList";
import NavbarList from "@/components/Navbar/NavbarList";
import NavbarUtilityBar from "@/components/Navbar/NavbarUtilityBar";
import { LAYOUT_HEADER_HEIGHT } from "@/configs/layout";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useNavbar } from "@/hooks/useNavbar";

import styles from "./LayoutDefault.module.css";

export const LayoutDefault = ({ children }: PropsWithChildren) => {
  const { isTablet } = useIsMobile();
  const { collapsed, toggleCollapsed, width, icon } = useNavbar();
  const { isAuthenticated } = useAuth();

  return (
    <AppShell
      withBorder={false}
      header={{ height: LAYOUT_HEADER_HEIGHT }}
      navbar={{
        width,
        breakpoint: "md",
        collapsed: { mobile: true },
      }}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
    >
      <AppShell.Header>
        <LayoutHeader />
      </AppShell.Header>

      <AppShell.Navbar withBorder py="xs" style={{ justifyContent: "space-between" }}>
        {collapsed ? <NavbarIconList /> : <NavbarList />}

        <Stack>
          <Divider my={4} />
          <NavbarUtilityBar withTerms={false} withLocale={!collapsed} statusCollapsed />
          <Center>
            <ActionIcon onClick={toggleCollapsed}>{icon}</ActionIcon>
          </Center>
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main
        pos="relative"
        classNames={{
          main: styles.main,
        }}
      >
        {children}
      </AppShell.Main>

      {!isAuthenticated && (
        <AppShell.Footer ml={isTablet ? "" : width}>
          <LayoutFooter />
        </AppShell.Footer>
      )}
    </AppShell>
  );
};

export default LayoutDefault;
